
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { APP_VERSION, BUILD_DATE } from '@/config/version'

// Log version info for debugging
console.log(`SnapRefund v${APP_VERSION} - Built: ${BUILD_DATE}`);

createRoot(document.getElementById("root")!).render(<App />);
